export enum ValidationResult {
	NOT_FOUND = 'NOT_FOUND',
	EXPIRATED_LINK = 'EXPIRATED_LINK',
	PREVIOUSLY_VALIDATED = 'PREVIOUSLY_VALIDATED',
	OK = 'OK',
	FAILED = 'FAILED',
}
